import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import {
  getPropertyNameWithLongAddress,
  getPropertyNameWithShortAddress
} from "shared/addressUtils";
import { unitStatus } from "shared/app/UnitsTableView/constants";
import { useMedia } from "shared/providers";
import { Unit } from "types/landlord/address";

interface HeaderUnitTitleSectionProps {
  unit?: Unit;
}

export const HeaderUnitTitleSection = ({
  unit
}: HeaderUnitTitleSectionProps) => {
  const { isMobile } = useMedia();

  return (
    <div className="flex w-full flex-col gap-2 border-b md:border-none border-alpha-40 py-4 md:py-0">
      {unit?.property ? (
        <p className="text-xs md:text-sm text-content-500 order-2 md:order-1 break-all">
          {isMobile
            ? getPropertyNameWithShortAddress(
                unit.property,
                unit.address ?? unit.property.address
              )
            : getPropertyNameWithLongAddress(
                unit.property,
                unit.address ?? unit.property.address
              )}
        </p>
      ) : null}

      {isMobile ? (
        <div className="flex justify-between items-center">
          <h4 className="truncate max-w-[220px] text-xl font-bold text-content-1000">
            {unit?.title}
          </h4>

          <Badge
            size={BadgeSize.SM}
            variant={
              unit?.occupied ? BadgeVariant.PRIMARY : BadgeVariant.SUCCESS
            }
          >
            {unitStatus(Boolean(unit?.occupied))}
          </Badge>
        </div>
      ) : (
        <h4 className="text-xl font-bold text-content-1000 order-1 md:order-2">
          {unit?.title}
        </h4>
      )}
    </div>
  );
};
